import inView from "in-view";

VIV.behaviours.blockTabs = (function () {

    const attach = function (context) {
        context.querySelectorAll('.blockTabs').forEach(element => {
            init(element);
        });
    };

    const init = function (element) {
        const buttons = element.querySelector('.blockTabs__buttons');
        buttons.classList.remove('blockTabs__buttons--visible');
        inView('.blockTabs__buttons')
            .on('enter', () => {
                buttons.classList.add('blockTabs__buttons--visible');
            })
            .on('exit', () => {
                buttons.classList.remove('blockTabs__buttons--visible');
            });
    };

    return {
        attach: attach
    }
})();
